import { Component, Shark } from "shark-mvc";
import moment from "moment";
import templateContent from "./date-range-filter.html";

class DateRangeFilterComponent extends Component {
	constructor() {
		super("dateRangeFilterComponent");

		this.addTemplate("", templateContent);
	}

	includeDate (date) {
		const dateRangeFilter = Shark.get("dateRangeFilter");

		return dateRangeFilter.ignoreDateRange || (dateRangeFilter.__from <= date && dateRangeFilter.__to >= date);
	}

	init () {
		const pagesToRefresh = ["constructionSiteListView", "constructionSiteCardListView", "leadListView", "notComplianceReportListView", "quotationListView", "sampleRequestListView", "siteInfoSheetListView", "visitListView"];
		const thisMonthFirstDay = moment().add(-30, "d");
		const thisMonthLastDay = moment().add(8, "M");

		let defaultSettings = {
			from: thisMonthFirstDay,
			ignoreDateRange: false,
			preset: "default",
			to: thisMonthLastDay,
			__from: thisMonthFirstDay.format("YYYY-MM-DD"),
			__to: thisMonthLastDay.format("YYYY-MM-DD"),
		};

		let dateRangeFilterSettings = localStorage.getItem("dateRangeFilterSettings");

		if (dateRangeFilterSettings) {
			dateRangeFilterSettings = JSON.parse(dateRangeFilterSettings);
			dateRangeFilterSettings.__from = moment(dateRangeFilterSettings.from).format("YYYY-MM-DD"),
			dateRangeFilterSettings.__to = moment(dateRangeFilterSettings.to).format("YYYY-MM-DD"),

			Object.assign(defaultSettings, dateRangeFilterSettings);
		}
	
		const dateRangeFilter = Shark.getInstance("__smart__", defaultSettings);
	
		dateRangeFilter.on("presetChanged", function () {
			let endDate;
			let startDate;
	
			switch (this.preset) {
				case "currentMonth":
					endDate = moment().endOf("month");
					startDate = moment().startOf("month");
					break;
				case "default":
					endDate = thisMonthLastDay;
					startDate = thisMonthFirstDay;
					break;
				case "lastMonth":
					endDate = moment().subtract(1, "month").endOf("month");
					startDate = moment().subtract(1, "month").startOf("month");
					break;
				case "nextMonth":
					endDate = moment().add(1, "month").endOf("month");
					startDate = moment().add(1, "month").startOf("month");
					break;
				case "currentYear":
					endDate = moment().endOf("year");
					startDate = moment().startOf("year");
					break;
				case "lastYear":
					endDate = moment().subtract(1, "year").endOf("year");
					startDate = moment().subtract(1, "year").startOf("year");
					break;
				case "nextYear":
					endDate = moment().add(1, "year").endOf("year");
					startDate = moment().add(1, "year").startOf("year");
					break;
			}
	
			if (endDate && startDate) {
				this.__from = startDate.format("YYYY-MM-DD");
				this.__to = endDate.format("YYYY-MM-DD");
				this.ignoreDateRange = false;
				this.from = startDate;
				this.to = endDate;

				localStorage.setItem("dateRangeFilterSettings", JSON.stringify(this.export()));

				//Meglio un evento?
				if (pagesToRefresh.indexOf(Shark.activePage.id) > -1) {
					if (typeof Shark.activePage.refreshList === "function") {
						Shark.activePage.refreshList();
					}
					else {
						console.warn("IL METODO refreshList non c'è!!!");
					}
				}
				else {
					Shark.render();
				}
			}
		});

		dateRangeFilter.on("dataChanged", function (event, data) {
			let render = false;
	
			switch (data.property) {
				case "ignoreDateRange":
					this.preset = "custom";
					render = true;
					break;
				case "__from":
					if (this.__to < this.__from) {
						this.__to = this.__from;
					}
					this.preset = "custom";
					render = true;
					break;
				case "__to":
					if (this.__from > this.__to) {
						this.__from = this.__to;
					}
					this.preset = "custom";
					render = true;
					break;
			}

			localStorage.setItem("dateRangeFilterSettings", JSON.stringify(this.export()));

			//Meglio un evento?
			if (pagesToRefresh.includes(Shark.activePage.id)) {
				if (typeof Shark.activePage.refreshList === "function") {
					Shark.activePage.refreshList();
				}
				else {
					console.warn("IL METODO refreshList non c'è!!!");
				}
			}
			else {
				if (render) {
					Shark.render();
				}
			}
		});
	
		this.set({
			currentMonthLabel: ` (${moment().format("MMM YY")})`,
			lastMonthLabel: ` (${moment().subtract(1, "M").format("MMM YY")})`,
			nextMonthLabel: ` (${moment().add(1, "M").format("MMM YY")})`,
			currentYearLabel: ` (${moment().format("YYYY")})`,
			lastYearLabel: ` (${moment().subtract(1, "y").format("YYYY")})`,
			nextYearLabel: ` (${moment().add(1, "y").format("YYYY")})`,
		});

		Shark.set({
			dateRangeFilter,
		});
	}
}

const dateRangeFilterComponent = new DateRangeFilterComponent();

Shark.registerComponent(dateRangeFilterComponent);

export { dateRangeFilterComponent };
